import React from "react";
import { useTranslation } from "react-i18next";
import { SimpleTable } from "simple-table-core";

export default function MyTable({ headers, rows }) {
  const { t } = useTranslation();

  const emptyState = (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <div style={{ fontSize: "16px", marginBottom: "8px" }}>{t("Data not found")}</div>
    </div>
  );

  const loadingState = (
    <div style={{ padding: "40px", textAlign: "center" }}>{t("Loading data...")}</div>
  );

  const errorState = (
    <div style={{ padding: "40px", textAlign: "center", color: "var(--red)" }}>
      {t("Error loading data")}
    </div>
  );

  return (
    <div className="table-container">
      <SimpleTable
        defaultHeaders={headers}
        // height={"500px"}
        rowIdAccessor="id"
        rows={rows}
        rowHeight={32}
        theme={"dark"}
        tableEmptyStateRenderer={emptyState}
        loadingStateRenderer={loadingState}
        errorStateRenderer={errorState}
      />
    </div>
  );
}
